/*
  Produktkachel Neue CI (snippets/flex-produkt-kachel.liquid):
  „In den Warenkorb“ per AJAX hinzufügen und den Warenkorb-Drawer öffnen
  (wie auf der Startseite). Event-Delegation am document, damit es auch nach
  Filter/Sortierung/Paginierung funktioniert (Dawn facets ersetzt das Grid).
  Ohne Drawer oder bei Netzfehler: normales POST auf /cart/add.
*/
(function () {
  if (window.__flexKachel) return;
  window.__flexKachel = true;

  function zeigeFehler(form, text) {
    var el = form.querySelector('.flex-kachel__fehler');
    if (!el) return;
    el.textContent = text || 'Der Artikel konnte nicht in den Warenkorb gelegt werden.';
    el.hidden = false;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('flex-kachel__form')) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return; /* Fallback: normales POST */
    e.preventDefault();

    var btn = form.querySelector('button[type="submit"]');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    var fehler = form.querySelector('.flex-kachel__fehler');
    if (fehler) fehler.hidden = true;

    function fertig() {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    }

    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer,cart-icon-bubble'); /* beide, sonst wirft renderContents */
    fd.append('sections_url', window.location.pathname);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        fertig();
        if (data && data.status) { /* z. B. nicht mehr verfügbar oder Höchstmenge erreicht */
          zeigeFehler(form, data.description || data.message);
          return;
        }
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
      })
      .catch(function () {
        fertig();
        form.submit();
      });
  });
})();
